module.exports = __webpack_public_path__ + "img/32.b2b413be.jpg";